import {
    OBSERVACIO_EXPORTACIO_INICIALITZAR,
    OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS
} from '../../../actions/actionTypes.js';

const ESTAT_INICIAL = '';

const dataInici = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case OBSERVACIO_EXPORTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS:
            return action.dataInici;

        default:
            return state;
    }
};

export default dataInici;



// WEBPACK FOOTER //
// ./src/reducers/observacio/exportacio/dataInici.js